import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useFormContext } from '../Form';
import { LoadingGrey, LoadingPrimary, LoadingSecondary } from '../Loading';
import { StyledButtonBabyPrimary, StyledButtonBabyRed, StyledButtonBabySecondary, StyledButtonPrimary, StyledButtonRed, StyledButtonSecondary, StyledButtonSubtlePrimary, StyledButtonSubtleSecondary, StyledLoadingDiv, StyledTextButtonPrimary, StyledTextButtonSecondary } from './Button.styled';
export var ButtonPrimary = createButton(StyledButtonPrimary, LoadingPrimary);
export var ButtonSecondary = createButton(StyledButtonSecondary, LoadingSecondary);
export var ButtonRed = createButton(StyledButtonRed, LoadingPrimary);
export var ButtonBabyPrimary = createButton(StyledButtonBabyPrimary, LoadingPrimary);
export var ButtonBabySecondary = createButton(StyledButtonBabySecondary, LoadingSecondary);
export var ButtonBabyRed = createButton(StyledButtonBabyRed, LoadingPrimary);
export var ButtonSubtlePrimary = createButton(StyledButtonSubtlePrimary, LoadingSecondary);
export var ButtonSubtleSecondary = createButton(StyledButtonSubtleSecondary, LoadingGrey);
export var ButtonTextPrimary = createButton(StyledTextButtonPrimary, LoadingPrimary);
export var ButtonTextSecondary = createButton(StyledTextButtonSecondary, LoadingPrimary);
function createButton(StyledButtonType, LoadingComponent) {
  return function Button(props) {
    var buttonRef = props.buttonRef,
      children = props.children,
      disabled = props.disabled,
      active = props.active,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      htmlProps = _objectWithoutProperties(props, ["buttonRef", "children", "disabled", "active", "type"]);
    var formContext = useFormContext();
    var activeOverride = active || type === 'submit' && formContext.active;
    var isDisabled = !!activeOverride || !!disabled;
    return /*#__PURE__*/React.createElement(StyledButtonType, _extends({}, htmlProps, {
      type: type,
      active: activeOverride,
      disabled: isDisabled,
      ref: buttonRef
    }), /*#__PURE__*/React.createElement("div", {
      tabIndex: -1
    }, activeOverride && /*#__PURE__*/React.createElement(StyledLoadingDiv, null, /*#__PURE__*/React.createElement(LoadingComponent, {
      size: 16,
      initialHeight: "100%",
      position: "absolute"
    })), children));
  };
}